export default "__VITE_ASSET__DEAMIESJ__"